import { BookingChoiceListTemplate } from '../booking-choice-list/w-booking-choice-list.template'

export const BookingFilterableServicesParticipantsChoiceListTemplate = (service) => {
  const data = {
    rooms: [
      {
        participants: [
          {
            choiceListInfo: {
              id: service.uid,
              name: service.uid,
              method: 'multiple',
              variant: 'boxed',
              highlighted: false,
              label: service.optionsLabel,
              extraClasses: 'w-booking-filterable-services__service-participants-choice-list',
              disabled: false,
              unresolved: false,
              attributes: {
                'data-w-booking-filterable-services__service-participants-choice-list': '',
                'data-w-booking-filterable-services__service-id': service.uid
              },
              items: service.participants
            }
          }
        ]
      }
    ]
  }
  return `<div class="w-booking-filterable-services__filter__content w-booking-filterable-services__participants-as-options">
            ${BookingChoiceListTemplate(data)}
          </div>`
}
